module.exports = __webpack_public_path__ + "media/images/png/friends-b8df0f81742c1268bc39dbe262af2099.png";